import { Box, Text } from '@chakra-ui/react';
import { useUser } from '@/constants/UserContext';
import { PageHeader } from '@/components/ui';

export function OrganizationsHeader() {
  const { user } = useUser();
  const greeting =
    user?.first_name
      ? `Hi, ${user.first_name}`
      : user?.email
        ? `Hi, ${user.email.split('@')[0]}`
        : 'Welcome back!';

  return (
    <PageHeader
      leftSlot={
        <Box px={{ base: 0, md: 1 }}>
          <Text
            as="h1"
            fontSize="xl"
            fontWeight="semibold"
            color="volyx.text"
            m={0}
            mb={1}
            lineHeight="tight"
          >
            {greeting}
          </Text>
          <Text fontSize="sm" color="volyx.darkGray" m={0}>
            Welcome back!
          </Text>
        </Box>
      }
    />
  );
}
